import React from 'react';

const InvoiceSettingsModal = ({
  open,
  onClose,
  settings,
  setSettings,
  savingSettings,
  onSave
}) => {
  if (!open) return null;
  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.35)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Configuración de facturas</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p className="text-muted small">Series y numeración general de las facturas.</p>
            <div className="row g-2 mb-3">
              <div className="col-md-8">
                <label className="form-label small">Serie de facturas normales</label>
                <input
                  className="form-control"
                  value={settings.series}
                  onChange={(e) => setSettings((p) => ({ ...p, series: e.target.value }))}
                  placeholder="FAC"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label small">Dígitos</label>
                <input
                  className="form-control"
                  type="number" min="1" max="8"
                  value={settings.seriesPad}
                  onChange={(e) => setSettings((p) => ({ ...p, seriesPad: Number(e.target.value || 1) }))}
                />
              </div>
            </div>
            <div className="row g-2">
              <div className="col-md-8">
                <label className="form-label small">Serie de facturas proforma</label>
                <input
                  className="form-control"
                  value={settings.proformaSeries}
                  onChange={(e) => setSettings((p) => ({ ...p, proformaSeries: e.target.value }))}
                  placeholder="PROF"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label small">Dígitos</label>
                <input
                  className="form-control"
                  type="number" min="1" max="8"
                  value={settings.proformaSeriesPad}
                  onChange={(e) => setSettings((p) => ({ ...p, proformaSeriesPad: Number(e.target.value || 1) }))}
                />
              </div>
            </div>
            <div className="row g-2">
              <div className="col-md-8">
                <label className="form-label small">Serie rectificativas</label>
                <input
                  className="form-control"
                  value={settings.rectificativaSeries}
                  onChange={(e) => setSettings((p) => ({ ...p, rectificativaSeries: e.target.value }))}
                  placeholder="RECT"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label small">Dígitos</label>
                <input
                  className="form-control"
                  type="number" min="1" max="8"
                  value={settings.rectificativaSeriesPad}
                  onChange={(e) => setSettings((p) => ({ ...p, rectificativaSeriesPad: Number(e.target.value || 1) }))}
                />
              </div>
            </div>
            <div className="row g-2 mt-2">
              <div className="col-md-6">
                <label className="form-label small">Plazo de pago por defecto (días)</label>
                <input
                  className="form-control"
                  type="number" min="0" max="365"
                  value={settings.defaultDueDays}
                  onChange={(e) => setSettings((p) => ({ ...p, defaultDueDays: Number(e.target.value || 0) }))}
                />
                <div className="text-muted small">Al crear una factura, su vencimiento será fecha + este nº de días.</div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cancelar</button>
            <button className="btn btn-primary" disabled={savingSettings} onClick={onSave}>
              {savingSettings ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSettingsModal;
